import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion } from 'framer-motion';
import faqData from '../data/faqData.json';

const FAQs = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          Frequently Asked Questions
        </p>
        <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl mb-5">
          Answers for You and Your Family
        </h2>
        <p className="text-bnBody text-base leading-relaxed max-w-2xl mx-auto mb-12">
          Everything you need to know about the home and aged care we provide, and how we support you and your family.
        </p>

        <div className="text-left">
          {faqData.map((faq) => {
            const open = openId === faq.id;
            return (
              <div key={faq.id} className="border-b border-bnBorder">
                <button
                  className="w-full flex items-center gap-3 text-left py-5 focus:outline-none"
                  onClick={() => toggleFAQ(faq.id)}
                >
                  <span className="text-bnAccent shrink-0">
                    {open ? <Minus size={20} /> : <Plus size={20} />}
                  </span>
                  <span className={`text-lg font-medium transition-colors ${open ? 'text-bnAccent' : 'text-bnInk'}`}>
                    {faq.question}
                  </span>
                </button>

                <motion.div
                  className="overflow-hidden"
                  initial={{ height: 0, opacity: 0 }}
                  animate={open ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                >
                  <div className="pb-6 pl-8 pr-2 text-bnBody text-sm leading-relaxed">
                    {faq.answer.map((paragraph, index) => (
                      <p key={index} className="mb-2">{paragraph}</p>
                    ))}
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
